import { environment } from "src/environments/environment";

export const endpoints = {
  allBookings: {
    getTripUrl: environment.analyticsURL + "/trip",
    tripCountUrl: environment.analyticsURL + "/trip/tripCount",
    tripDownloadUrl: environment.analyticsURL + "/trip/download",
    tripDetailUrl: environment.tripURL + "/trip/requests",
    estimationDetailUrl: environment.tripURL + "/trip/logs/estimate",
    tripMetricsUrl: environment.trackURL + "/metrics",
    tripTransactionLogsUrl: environment.paymentURL + "/logs",
    tripBreakdownLogsUrl: environment.tripURL + "/trip/logs",
    endTripUrl: environment.tripURL + "/trip/requests/end",
    allTripNotificationUrl: environment.notificationURL + "/view/notifications",
    callBackCheckNotificationUrl: environment.notificationURL + "/view/notifications/callback",
    scheduledTripCountUrl: environment.analyticsURL + "/trip/tripHourlyOrScheduledCount",
    assignChauffeurUrl: environment.tripURL + "/manage/assign",
    rejectUrl: environment.tripURL + "/manage/reject",
    enableNotifyUrl: environment.tripURL + "/trip/requests/enable-notify",
    handoffUrl: environment.tripURL + "/manage/handoff",
    validateChauffeurUrl: environment.tripURL + "/manage/assignment",
    tripChatUrl: environment.chatUrl + "/chat/getTripChat",
    tripRequestProcessUrl: environment.analyticsURL + "/trip/tripRequestProcessDetails",
    changeCarCategoryUrl: environment.tripURL + "/manage/change-scheduled-trip-car-category",
    changeTripTimeUrl: environment.tripURL + "/manage/change-scheduled-time",
    customerCollectorUrl: environment.collectorUrl + "/customer/eta",
    chauffeurDirectionLinkUrl: environment.collectorUrl + "/chauffeur/direction-click",
    createTripFineUrl: environment.tripURL + "/manage/fine",
    getTripFineUrl: environment.tripURL + "/manage/fine",
    refundTripFineUrl: environment.tripURL + "/manage/fine/refund",
    createPaymentLinkUrl: environment.tripURL + "/manage/create-payment-link",
    liveBillUrl: environment.tripURL + "/trip/logs/bill",
    activateUberSourceTokenUrl: environment.tripURL + "/tokens/supplier/uber/token",
  },
  cars: {
    carDetailUrl: environment.carURL + "/car",
    createCarUrl: environment.carURL + "/car/create",
    updateCarUrl: environment.carURL + "/car/updateCar",
    getPartnerUrl: environment.analyticsURL + "/partner/activePartnerList",
    carListUrl: environment.analyticsURL + "/car",
    carCountListUrl: environment.analyticsURL + "/car/carCount",
    downloadCarExcelUrl: environment.analyticsURL + "/car/download",
    changeCarStatusUrl: environment.carURL + "/car/change-status",
    rejectCarUrl: environment.carURL + "/car/reject",
    reinstateCarUrl: environment.carURL + "/car/reinstate",
    getCarCategoryUrl: environment.carURL + "/carType",
    carAdministratorLogUrl: environment.analyticsURL + "/car/administration",
    chaufferListUrl: environment.analyticsURL + "/chauffer/chaufferList",
    assignedCarChauffeurUrl: environment.analyticsURL + "/car/getCarAssignChauffeur",
    assignedCarList: environment.carURL + "/assignment/list",
    selectCarForDriving: environment.carURL + "/assignment/select",
    carEarningsUrl: environment.analyticsURL + "/car/car-earnings",
    carEarningsBreakdownUrl: environment.analyticsURL + "/car/car-earnings-breakdown",
  },
  report: {
    getReportsUrl: environment.reportURL + "/report",
    getReportsDownloadUrl: environment.reportURL + "/report/download",
    getReportsCountUrl: environment.reportURL + "/report/count",
    getReportDetailsByReportIdUrl: environment.reportURL + "/report/details",
    getReportBreakDownUrl: environment.reportURL + "/breakdown",
    downloadReportBreakDownUrl: environment.reportURL + "/breakdown/download",
    settlementUrl: environment.reportURL + "/settlement",
    updateSettlementStatusUrl: environment.reportURL + "/settlement/status",
    getReportTransactionLogsUrl: environment.reportURL + "/settlement/logs",
    downloadEarningReportUrl: environment.reportURL + "/chauffeur/earnings/download",
    rideReimbursementInsightsUrl:
      environment.reportURL + "/reimbursements/ride/insights",
    rideReimbursementPartnersUrl:
      environment.reportURL + "/reimbursements/ride/partners",
    rideReimbursementPartnerDetailUrl:
      environment.reportURL + "/reimbursements/ride/partners",
    rideReimbursementChauffeurTripsUrl:
      environment.reportURL + "/reimbursements/ride/partners",
  },
  // Earnings module - served by ourlane-reports (routes mounted at /earnings)
  earnings: {
    driversUrl: environment.reportURL + "/earnings/drivers",
    driverDetailUrl: environment.reportURL + "/earnings/drivers",
    driversDownloadUrl: environment.reportURL + "/earnings/drivers/download",
    partnersUrl: environment.reportURL + "/earnings/partners",
    partnerDetailUrl: environment.reportURL + "/earnings/partners",
    partnersDownloadUrl:
      environment.reportURL + "/earnings/partners/download",
    partnerSummaryUrl: environment.reportURL + "/earnings/partners/summary",
    // partner counters, served by its own controller: the figures come from the
    // reports collection rather than the earnings ledger
    partnerCountsUrl: environment.reportURL + "/earnings/partners/counts",
    endBalanceUrl: environment.reportURL + "/earnings/end-balance",
  },
  invoice: {
    invoiceListUrl: environment.reportURL + "/invoice",
    invoiceDetailsUrl: environment.reportURL + "/invoice/details",
  },
  yachtReport: {
    getReportsUrl: environment.yachtAnalyticsUrl + "/report/list",
    getReportsDownloadUrl: environment.yachtAnalyticsUrl + "/report/download",
    getReportsCountUrl: environment.yachtAnalyticsUrl + "/report/count",
    getReportDetailsByReportIdUrl: environment.yachtAnalyticsUrl + "/report/details",
    getReportBreakDownUrl: environment.yachtAnalyticsUrl + "/report/breakdown",
    downloadReportBreakDownUrl: environment.yachtAnalyticsUrl + "/report/breakdown/download",
    settlementUrl: environment.yachtAnalyticsUrl + "/report/settlement",
    updateSettlementStatusUrl: environment.yachtAnalyticsUrl + "/report/settlement/status",
    getReportTransactionLogsUrl: environment.yachtAnalyticsUrl + "/report/settlement/logs",
  },
  carRentalReport: {
    getReportsUrl: environment.rentalAnalyticsUrl + "/report/list",
    getReportsDownloadUrl: environment.rentalAnalyticsUrl + "/report/download",
    getReportsCountUrl: environment.rentalAnalyticsUrl + "/report/count",
    getReportDetailsByReportIdUrl: environment.rentalAnalyticsUrl + "/report/details",
    getReportBreakDownUrl: environment.rentalAnalyticsUrl + "/report/breakdown",
    downloadReportBreakDownUrl: environment.rentalAnalyticsUrl + "/report/breakdown/download",
    settlementUrl: environment.rentalAnalyticsUrl + "/report/settlement",
    updateSettlementStatusUrl: environment.rentalAnalyticsUrl + "/report/settlement/status",
    getReportTransactionLogsUrl: environment.rentalAnalyticsUrl + "/report/settlement/logs",
    generateReportUrl: environment.rentalAnalyticsUrl + "/report/generate",
  },
  kpi: {
    getMonthlyTripsUrl: environment.analyticsURL + "/kpi/monthly-trip",
    getTripRatingUrl: environment.analyticsURL + "/kpi/tripWithRating",
    getFullfillmentRateUrl: environment.analyticsURL + "/kpi/fullfillmentRate",
    getPeakHourDriverCountUrl: environment.analyticsURL + "/kpi/peakHourDriverCount",
  },
  carTypes: {
    createCarTypeUrl: environment.carURL + "/carType",
    getCarTypeUrl: environment.carURL + "/carType",
    getCarTypesDownloadUrl: environment.carURL + "/carType/download",
    updateCarTypeUrl: environment.carURL + "/carType",
  },
  auth: {
    loginUrl: environment.userURL + "/auth",
    verifyUrl: environment.userURL + "/auth/verify",
    resendUrl: environment.userURL + "/auth/resend",
    meUrl: environment.userURL + "/me",
  },
  staticPage: {
    termsAndCondition: environment.staticURL + "/managePages/getManagePage/termsAndCondition",
    privacyPolicy: environment.staticURL + "/managePages/getManagePage/privacyPolicy",
    fineReasonUrl: environment.staticURL + "/fine-configuration",
    createFineReasonUrl: environment.staticURL + "/fine-configuration",
    updateFineReasonUrl: environment.staticURL + "/fine-configuration",
    fineListUrl: environment.staticURL + "/fine-configuration/list",
  },
  paymentPage: {
    retrievePaymentUrl: environment.paymentURL + "/stripePayment/retrievePaymentMethods",
    retrieveCustomerUrl: environment.paymentURL + "/stripePayment/retrieveCustomer",
    cancelFare: environment.tripURL + "/manage/default",
    addRefund: environment.tripURL + "/manage/refund",
    editRefund: environment.tripURL + "/manage/refund/",
    getRefundedTransactions: environment.tripURL + "/manage/refund/list",
    getCancelFareTransactions: environment.tripURL + "/manage/default",
  },
  partnerPage: {
    createPartner: environment.userURL + "/partner",
    // editPartner: environment.userURL + "/partner/",
    getPartnerDetails: environment.userURL + "/partner/",
    getPartners: environment.analyticsURL + "/partner/",
    getPartnersAnalytics: environment.partnerAnalyticsURL + "/analytics/list/",
    getPartnersDetailAnalytics: environment.partnerAnalyticsURL + "/analytics/partner/",
    getPartner: environment.userURL + "/partner",
    changePartnerStatus: environment.userURL + "/partner/change-status/",
    partnerUrl: environment.userURL,
    getPartnerCountUrl: environment.analyticsURL + "/partner/partnerCount",
    getPartnersAnalyticsCountUrl: environment.partnerAnalyticsURL + "/analytics",
    getPartnerDownloadUrl: environment.analyticsURL + "/partner/download",
    getPartnerAnalyticsDownloadUrl: environment.partnerAnalyticsURL + "/analytics",  
    updateIdentityDocuments: environment.partnerAnalyticsURL + "/onboarding",
    invitePartner: environment.partnerAnalyticsURL + "/analytics/invited",
    actionUrl: environment.partnerAnalyticsURL + "/admin/action",
    getPartnerUrl: environment.partnerAnalyticsURL + "/analytics/search",
    partnerDocumentConfig: environment.partnerAnalyticsURL + "/partner-document-config",
    editPartner: environment.partnerAnalyticsURL + "/partner-details/update",
    updateSpocPhoneUrl: environment.partnerAnalyticsURL + "/partner-details/partner",
    updateSpocEmailUrl: environment.partnerAnalyticsURL + "/partner-details/partner",
    rejectionReasonUrl: environment.partnerAnalyticsURL + "/onboarding/rejection-reason",
    administrationLogsUrl: environment.partnerAnalyticsURL + "/partner-details/administration-logs",
  },
  customerPage: {
    changeStatus: environment.userURL + "/user/action/",
    deviceDetails: environment.userURL + "/user/device-details",
    otpDetails: environment.userURL + "/user/last-generated-otp",
    getCustomerUrl: environment.analyticsURL + "/customer/customerQuotation",
    getCustomerTotalSpendUrl: environment.analyticsURL + "/customer/totalSpend",
    getCarTypePerformanceUrl: environment.analyticsURL + "/customer/carTypeWiseTrip",
    getCustomerDocumentUrl: environment.userURL + "/document",
    adminManageCustomerUrl: environment.userURL + "/document/admin/manage",
    kycRejectionNotesUrl: environment.userURL + "/document/kyc-rejection-notes",
  },
  driverPage: {
    getChaufferUrl: environment.analyticsURL + "/chauffer",
    getChaufferCountUrl: environment.analyticsURL + "/chauffer/chaufferCount",
    getChaufferDownloadUrl: environment.analyticsURL + "/chauffer/download",
    driverUrl: environment.userURL + "/driver",
    driverDetailUrl: environment.driverURL + "/analytics/driver",
    assignCarUrl: environment.userURL + "/driver/assign-car",
    changeStatusUrl: environment.userURL + "/driver/change-status",
    performanceUrl: environment.analyticsURL + "/chauffer/performance",
    workingUrl: environment.analyticsURL + "/chauffer/working",
    activityUrl: environment.analyticsURL + "/chauffer/activity",
    earningsUrl: environment.analyticsURL + "/chauffer/driver-earnings",
    driverEarningsUrl: environment.analyticsURL + "/chauffer/earnings",
    acceptanceRateUrl: environment.analyticsURL + "/chauffer/acceptance-rate",
    activeChauffer: environment.analyticsURL + "/chauffer/activeChauffer",
    changeStateByAdmin: environment.userURL + "/driver/update-state-by-admin",
    fleetCount: environment.analyticsURL + "/chauffer/fleet-count",
    otpDetails: environment.driverURL + "/me/last-generated-otp",
    driverTripDetailsUrl: environment.analyticsURL + "/trip/driverTripDetails",
    driverRegisteredAnalyticsUrl: environment.driverURL + "/analytics/list/registered",
    driverOnboardingAnalyticsUrl: environment.driverURL + "/analytics/list/onboarding",
    driverRegisteredSummaryUrl: environment.driverURL + "/analytics/summary/registered",
    driverOnboardingSummaryUrl: environment.driverURL + "/analytics/summary/onboarding",
    driverRegisteredDownloadUrl: environment.driverURL + "/analytics/registered/download",
    driverOnboardingDownloadUrl: environment.driverURL + "/analytics/onboarding/download",
    updateIdentityDocuments: environment.driverURL + "/onboarding",
    chauffeursInvitationUrl : environment.driverURL + "/chauffeurs/invitation",
    chauffeursInvitationRevokeUrl: environment.driverURL + "/chauffeurs/invitation",
    chauffeursInvitationAcceptUrl: environment.driverURL + "/chauffeurs/invitation",
    chauffeursInvitationRejectUrl: environment.driverURL + "/chauffeurs/invitation",
    actionUrl: environment.driverURL + "/admin/action",
    driverDocumentConfig: environment.driverURL + "/driver-document-config",
    rejectionReasonUrl: environment.driverURL + "/onboarding/reject",
    rejectionNotesUrl: environment.driverURL + "/onboarding/rejection-notes",
    statusActionHistoryUrl: environment.driverURL + "/admin/activation-logs",
    driverDetailsUrl: environment.driverURL + "/driver-details",
    driverUpdatePhoneUrl: environment.driverURL + "/driver-details/driver",
    invitationDetailsUrl: environment.driverURL + "/analytics/onboarding/detail",
    getAdministrativeLogsUrl: environment.driverURL + "/me/get-administrative-logs",
  },
  analyticsPage: {
    getCustomerUrl: environment.analyticsURL + "/customer",
    getCustomerCountUrl: environment.analyticsURL + "/customer/customerCount",
    getCustomerDownloadUrl: environment.analyticsURL + "/customer/download",
    getAdministrativeLogsUrl: environment.userURL + "/user/get-administrative-logs",
    getPaymentCustomerUrl: environment.paymentURL + "/digital/paymentMethod",
    getSubscriptionsCount: environment.personalAssistantAnalyticsURL + "/counts",
  },
  dashboardPage: {
    getDashboardKeyInsights: environment.analyticsURL + "/dashboard/dashboardKeyInsights",
    getDashboardRevenue: environment.analyticsURL + "/dashboard/revenue",
    getDashboardTotalRevenue: environment.analyticsURL + "/dashboard/total-revenue",
    getDashboardBookings: environment.analyticsURL + "/dashboard/bookings",
    getDashboardCustomerRegistrations: environment.analyticsURL + "/dashboard/customers",
    getDashboardKeyPerformance: environment.analyticsURL + "/dashboard/tripsPerformance",
    getDashboardTopCustomers: environment.analyticsURL + "/dashboard/topCustomers",
    getDashboardTopChauffeurs: environment.analyticsURL + "/dashboard/topDrivers",
    getTripFineUrl: environment.analyticsURL + "/fine/count",
  },
  cancellationReasonPage: {
    createCancellationReason: environment.staticURL + "/static/reason",
    getCancellationReason: environment.staticURL + "/static/reason/control",
    downloadCancellationReason: environment.staticURL + "/static/reason/download",
    updateCancellationReason: environment.staticURL + "/static/reason",
    deleteCancellationReason: environment.staticURL + "/static/reason",
  },
  sockets: {
    tripSocket: environment.socketURL,
  },
  feed: {
    getFeedUrl: environment.notificationURL + "/feed",
  },
  carModels: {
    createCarModels: environment.carURL + "/carModel",
    getCarModels: environment.carURL + "/carModel",
    updateCarModels: environment.carURL + "/carModel",
  },
  marketingConfiguration: {
    createMarketingConfiguration: environment.staticURL + "/marketing",
    getMarketingConfigurations: environment.staticURL + "/marketing/list",
    updateMarketingConfigurationWithFile: environment.staticURL + "/marketing",
    downloadMarketingConfigurations: environment.staticURL + "/marketing/download",
    deleteMarketingConfiguration: environment.staticURL + "/marketing",
  },
  fleet: {
    hotZones: environment.analyticsURL + "/analytics/hot-zones",
    categoryCount: environment.analyticsURL + "/analytics/category-count",
  },
  copilot: {
    getSettingAvailability: environment.copilotUrl + "/availability",
    setSettingAvailability: environment.copilotUrl + "/availability/model",
    seCarAvailability: environment.copilotUrl + "/availability/car",
    getTripPreferenceUrl: environment.copilotUrl + "/preference",
  },
  tenant: {
    getTenantUrl: environment.analyticsURL + "/tenant",
  },
  yacht: {
    sightUrl: environment.yachtUrl + "/sight",
    boardingPointUrl: environment.yachtUrl + "/boardingPoint",
    partnerUrl: environment.yachtUrl + "/partner",
    changeYachtPartnerStatus: environment.yachtUrl + "/partner/action/",
    updateSpocPhoneUrl: environment.yachtUrl + "/partner",
    updateSpocEmailUrl: environment.yachtUrl + "/partner",
    cateringUrl: environment.yachtUrl + "/addons/catering",
    waterSportsUrl: environment.yachtUrl + "/addons/water-sports",
    miscellaneous: environment.yachtUrl + "/addons/miscellaneous",
    routesUrl: environment.yachtUrl + "/routes",
    yachtUrl: environment.yachtUrl + "/yacht",
    yachtAnalyticsUrl: environment.yachtUrl + "/yacht/yacht-analytics",
    yachtStatusCountUrl: environment.yachtUrl + "/yacht/status-count",
    yachtActionUrl: environment.yachtUrl + "/yacht/action",
    yachtDownloadUrl: environment.yachtUrl + "/yacht/download",
    facilitiesUrl: environment.yachtUrl + "/feature/facilities",
    amenitiesUrl: environment.yachtUrl + "/feature/amenities",
    addonsUrl: environment.yachtUrl + "/yacht/addons",
  },
  yachtAnalytics: {
    analyticsYachtQuotesUrl: environment.yachtAnalyticsUrl + "/dashboard/yacht-quotes",
    analyticsYachtBookingExportUrl: environment.yachtAnalyticsUrl + "/booking/list/export",
    analyticsYachtBookingTotalSpendUrl: environment.yachtAnalyticsUrl + "/booking/total-spend",
    analyticsYachtBookingDashboardKeyInsightsUrl: environment.yachtAnalyticsUrl + "/dashboard/dashboard-key-insights",
    analyticsYachtServiceRevenueUrl: environment.yachtAnalyticsUrl + "/dashboard/service-revenue",
    analyticsYachtPlatformRevenueUrl: environment.yachtAnalyticsUrl + "/dashboard/platform-revenue",
    analyticsYachtBookingsUrl: environment.yachtAnalyticsUrl + "/dashboard/bookings",
    analyticsYachtPerformanceUrl: environment.yachtAnalyticsUrl + "/dashboard/yacht-performance",
    analyticsYachtBookingListUrl: environment.yachtAnalyticsUrl + "/booking/list",
    analyticsYachtBookingStatusCountUrl: environment.yachtAnalyticsUrl + "/booking/status-count",
  },
  carAnalytics: {
    analyticsCarQuotesUrl: environment.analyticsURL + "/dashboard/car-quotes",
  },
  yachtBooking: {
    yachtBookingUrl: environment.yachtBookingUrl + "/requests/info",
    yachtBookingUpdateUrl: environment.yachtBookingUrl + "/requests/update",
    yachtBookingUpdateListUrl: environment.yachtBookingUrl + "/requests/update/list",
    yachtAdminBookingListExportUrl: environment.yachtBookingUrl + "/admin/booking/list/export",
    yachtAdminBookingActionUrl: environment.yachtBookingUrl + "/requests/action",
    yachtAdminBookingUpdateActionUrl: environment.yachtBookingUrl + "/requests/update/action",
    yachtTransactionUrl: environment.yachtBookingUrl + "/transaction/list",
    yachtAdminTransactionUrl: environment.yachtBookingUrl + "/admin/transaction/refund",
    yachtOperatorNotesUrl: environment.yachtBookingUrl + "/requests/operator-notes",
    yachtOperatorNotesCreateUrl: environment.yachtBookingUrl + "/requests/operator-notes/create",
    yachtOperatorNotesUpdateUrl: environment.yachtBookingUrl + "/requests/operator-notes/update",
    yachtAddonsUrl: environment.yachtBookingUrl + "/requests/addons",
    lockedRateUrl: environment.yachtBookingUrl + "/requests/locked-rate",
    paymentUrl: environment.yachtBookingUrl + "/payment",
  },
  personalAssistant: {
    services: {
      createOneUrl: environment.personalAssistantURL + "/service-list",
      updateOneUrl: environment.personalAssistantURL + "/service-list",
      deleteOneUrl: environment.personalAssistantURL + "/service-list",
      getManyUrl: environment.personalAssistantAnalyticsURL + "/service-list",
      downloadManyUrl: environment.personalAssistantAnalyticsURL + "/service-list/download",
    },

    packages: {
      createOneUrl: environment.personalAssistantURL + "/packages",
      updateOneUrl: environment.personalAssistantURL + "/packages",
      deleteOneUrl: environment.personalAssistantURL + "/packages",
      getManyUrl: environment.personalAssistantAnalyticsURL + "/packages",
      downloadManyUrl: environment.personalAssistantAnalyticsURL + "/packages/download",
    },

    customPackages: {
      createOneUrl: environment.personalAssistantURL + "/custom-packages",
      updateOneUrl: environment.personalAssistantURL + "/custom-packages",
      deleteOneUrl: environment.personalAssistantURL + "/custom-packages",
      getManyUrl: environment.personalAssistantAnalyticsURL + "/custom-packages",
      downloadManyUrl: environment.personalAssistantAnalyticsURL + "/custom-packages/download",
    },

    subscriptionsUrl: {
      getManyUrl: environment.personalAssistantAnalyticsURL + "/subscriptions",
      getCurrentUrl: environment.personalAssistantURL + "/subscriptions/current",
      downloadManyUrl: environment.personalAssistantAnalyticsURL + "/subscriptions/download",
      getOneCustomerUrl: environment.personalAssistantURL + "/subscriptions",
      getOneCustomerCurrentUrl: environment.personalAssistantURL + "/subscriptions/current",
      action: environment.personalAssistantURL + "/subscriptions/action",
      logs: {
        getManyUrl: environment.personalAssistantURL + "/subscription-logs",
        downloadManyUrl: environment.personalAssistantURL + "/subscription-logs/download",
      },
      getSubscriptionsCount: environment.personalAssistantAnalyticsURL + "/subscriptions/counts",
      dashboardAnalyticsUrl: environment.personalAssistantAnalyticsURL + "/dashboard/getActiveSubscriptions",
      subscriptionsAnalytics: environment.personalAssistantAnalyticsURL + "/subscriptions",
      subscriptionsActiveCustomer: environment.personalAssistantURL + "/subscriptions/customer/active-customer-subscription",
    },

    payments: {
      dashboardServiceRevenueAnalyticsUrl: environment.personalAssistantAnalyticsURL + "/dashboard/getServiceRevenue",
    },

    tasks: {
      getManyUrl: environment.personalAssistantAnalyticsURL + "/tasks",
      downloadManyUrl: environment.personalAssistantAnalyticsURL + "/tasks/download",
      getAnalyticsUrl: environment.personalAssistantAnalyticsURL + "/tasks/counts",
      createOneUrl: environment.personalAssistantURL + "/tasks",
      updateOneUrl: environment.personalAssistantURL + "/tasks",
      getOneUrl: environment.personalAssistantURL + "/tasks",
      actionUrl: environment.personalAssistantURL + "/tasks/action",
      dashboard: {
        serviceRequestsCountsAnalyticsUrl:
          environment.personalAssistantAnalyticsURL + "/dashboard/getServiceRequestsCounts",
        performanceAnalyticsUrl: environment.personalAssistantAnalyticsURL + "/dashboard/getPerformance",
      },
    },

    subTasks: {
      createOneUrl: environment.personalAssistantURL + "/sub-tasks",
      updateOneUrl: environment.personalAssistantURL + "/sub-tasks",
      deleteOneUrl: environment.personalAssistantURL + "/sub-tasks",
      completedOneUrl: environment.personalAssistantURL + "/sub-tasks" + "/action",
      timeLogs: {
        createOneUrl: environment.personalAssistantURL + "/sub-tasks-time-logs",
        updateOneUrl: environment.personalAssistantURL + "/sub-tasks-time-logs",
        deleteOneUrl: environment.personalAssistantURL + "/sub-tasks-time-logs",
      },
    },
   
  },
  alert: {
    getActivityAlertListUrl: environment.alertUrl + "/activity/alert/list",
    getStopMonitoringListUrl: environment.alertUrl + "/stop/monitoring/list",
    getTripRouteUrl: environment.alertUrl + "/trip/route",
  },
  configurations: {
    getOfferingsUrl: environment.configurationsUrl + "/offerings",
    getOfferingsListUrl: environment.configurationsUrl + "/offerings/list",
    getOfferingsSearchUrl: environment.configurationsUrl + "/offerings/search",
    getTenantUrl: environment.configurationsUrl + "/tenant",
    getCountryUrl: environment.configurationsUrl + "/tenant/country",
    getOfferingsCountryUrl: environment.configurationsUrl + "/offerings/country",
    getOfferingsCountrySearchUrl: environment.configurationsUrl + "/offerings/country/search",
    getCustomerDocumentConfigUrl: environment.configurationsUrl + "/customer-document-config",

  },
  rental: {
    // Asset/operations endpoints → moniic-car-rental-manager (local: localhost:4081/rental/asset/v1)
    boardingPointUrl: (environment as any).rentalAssetUrl + "/boardingPoint",
    facilitiesUrl: (environment as any).rentalAssetUrl + "/feature/facilities",
    amenitiesUrl: (environment as any).rentalAssetUrl + "/feature/amenities",
    cateringUrl: (environment as any).rentalAssetUrl + "/addons/catering",
    miscellaneousUrl: (environment as any).rentalAssetUrl + "/addons/miscellaneous",
    insuranceUrl: (environment as any).rentalAssetUrl + "/addons/insurance",
    rentalStatusCountUrl: (environment as any).rentalAssetUrl + "/rental/status-count",
    rentalActionUrl: (environment as any).rentalAssetUrl + "/asset/action",
    rentalDownloadUrl: (environment as any).rentalAssetUrl + "/asset/download",
    rentalUrl: (environment as any).rentalAssetUrl + "/rental",
    assetUrl: (environment as any).rentalAssetUrl + "/asset",
    addonsUrl: (environment as any).rentalAssetUrl + "/asset/addons",
    rentalAnalyticsUrl: (environment as any).rentalAssetUrl + "/asset/asset-analytics",
    // Partner management endpoints → moniic-rental-partner-service (local: localhost:3050/rental/partner/v1)
    partnerUrl: (environment as any).rentalAssetUrl + "/partner",
    partnerDetailUrl: environment.rentalUrl + "/partner",
    partnerOnboardingUrl: environment.rentalUrl + "/onboarding",
    changeRentalPartnerStatus: (environment as any).rentalAssetUrl + "/partner/action/",
    updateSpocPhoneUrl: environment.rentalUrl + "/partner-details/partner",
    updateSpocEmailUrl: environment.rentalUrl + "/partner-details/partner",
  },
  rentalBooking: {
    rentalBookingUrl: environment.rentalAnalyticsUrl + "/booking/list",
    rentalBookingExportUrl: environment.rentalAnalyticsUrl + "/booking/list/export",
    rentalBookingStatusCountUrl: environment.rentalAnalyticsUrl + "/booking/status-count", 
    rentalBookingTotalSpendUrl: environment.rentalAnalyticsUrl + "/booking/total-spend", 
    rentalBookingInfoUrl: environment.rentalBookingUrl + "/requests/info",
    rentalTransactionUrl: environment.rentalBookingUrl + "/transaction/list", 
    rentalBookingActionUrl: environment.rentalBookingUrl + "/requests/action",
    rentalBookingCompleteUrl: environment.rentalBookingUrl + "/requests/complete",
    rentalAddonsUrl: environment.rentalBookingUrl + "/requests/addons",
    lockedRateUrl: environment.rentalBookingUrl + "/requests/locked-rate",
    rentalAdminTransactionUrl: environment.rentalBookingUrl + "/admin/transaction/refund",
    rentalOperatorNotesUrl: environment.rentalBookingUrl + "/requests/operator-notes",
    rentalOperatorNotesCreateUrl: environment.rentalBookingUrl + "/requests/operator-notes/create",
    rentalOperatorNotesUpdateUrl: environment.rentalBookingUrl + "/requests/operator-notes/update",
    paymentUrl: environment.rentalBookingUrl + "/payment",
    rentalBookingUpdateUrl: environment.rentalBookingUrl + "/requests/update",
    rentalBookingUpdateListUrl: environment.rentalBookingUrl + "/requests/update/list",
    rentalBookingUpdateActionUrl: environment.rentalBookingUrl + "/requests/update/action",
    rentalBookingFineUrl: environment.rentalBookingUrl + "/requests/fine",
    rentalImageDownloadUrl:
      environment.rentalBookingUrl + "/image/download/image",
    rentalBookingFineActionUrl: environment.rentalBookingUrl + "/requests/fine/action",
    settlementSummaryUrl: environment.rentalBookingUrl + "/requests/fine/settlement-summary",
    depositProcessUrl: environment.rentalBookingUrl + "/deposit/process",
    rentalBookingDistanceUsedUrl: environment.rentalBookingUrl + "/requests/distance-used",
    rentalBookingDistanceUsedActionUrl:
      environment.rentalBookingUrl + "/requests/distance-used/action",
    /** Per-tenant duration-band discount config (moniic-car-rental-booking). */
    rentalDiscountUrl: environment.rentalBookingUrl + "/asset/discount",
  },
  rentalAnalytics: {
    analyticsRentalQuotesUrl: environment.rentalAnalyticsUrl + "/dashboard/asset-quotes",
    analyticsRentalBookingDashboardKeyInsightsUrl: environment.rentalAnalyticsUrl + "/dashboard/dashboard-key-insights",
    analyticsRentalServiceRevenueUrl: environment.rentalAnalyticsUrl + "/dashboard/service-revenue",
    analyticsRentalPlatformRevenueUrl: environment.rentalAnalyticsUrl + "/dashboard/platform-revenue",
    analyticsRentalBookingsUrl: environment.rentalAnalyticsUrl + "/dashboard/bookings",
    analyticsRentalPerformanceUrl: environment.rentalAnalyticsUrl + "/dashboard/asset-performance",

  },
  vehicleMasterData: {
    vehicleTypes: (environment as any).rentalAssetUrl + "/master-data/vehicle-types",
    vehicleBrands: (environment as any).rentalAssetUrl + "/master-data/vehicle-brands",
    vehicleModels: (environment as any).rentalAssetUrl + "/master-data/vehicle-models",
    vehicleHierarchy: (environment as any).rentalAssetUrl + "/master-data/vehicle-hierarchy",
  },
  referral: {
    adminDriverReferrals: environment.referralURL + "/admin/referrals",
    adminCustomerReferrals: environment.referralURL + "/admin/customer-referrals",
    configList: environment.referralURL + "/admin/config",
    configUpsert: environment.referralURL + "/admin/config",
    configBulkUpsert: environment.referralURL + "/admin/config",
    adminPayouts: environment.referralURL + "/admin/payouts",
    adminAnalytics: environment.referralURL + "/admin/analytics",
    driverBankDetails: environment.referralURL + "/referral/bank-details",
  },
  parkingReimbursement: {
    insights: environment.tripURL + "/manage/parking-reimbursement/insights",
    list: environment.tripURL + "/manage/parking-reimbursement/list",
    detail: environment.tripURL + "/trip/parking/reimbursement",
    action: environment.tripURL + "/manage/parking-reimbursement/action",
    download: environment.tripURL + "/manage/parking-reimbursement/download",
  },
};
